//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["workXmlFile","masterXmlFile","compareOptions"],"CompareXmlFiles",{R_:{result:''}},3,0]],[]];
SPLM.Validate.XmlComparator = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Validate.XmlComparator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.XmlComparator.Options = class{
    constructor(filterFile,reportFile,logFile,ignoreNamespaces,ignoreUnmatchedNodes,ignoreComments,ignoreCdata,ignorePI){
        this.filterFile=filterFile;this.reportFile=reportFile;this.logFile=logFile;this.ignoreNamespaces=ignoreNamespaces;this.ignoreUnmatchedNodes=ignoreUnmatchedNodes;this.ignoreComments=ignoreComments;this.ignoreCdata=ignoreCdata;this.ignorePI=ignorePI;}
    get Filterfile(){return this.filterFile}
    set Filterfile(val){this.filterFile = val}
    get Reportfile(){return this.reportFile}
    set Reportfile(val){this.reportFile = val}
    get Logfile(){return this.logFile}
    set Logfile(val){this.logFile = val}
    get Ignorenamespaces(){return this.ignoreNamespaces}
    set Ignorenamespaces(val){this.ignoreNamespaces = val}
    get Ignoreunmatchednodes(){return this.ignoreUnmatchedNodes}
    set Ignoreunmatchednodes(val){this.ignoreUnmatchedNodes = val}
    get Ignorecomments(){return this.ignoreComments}
    set Ignorecomments(val){this.ignoreComments = val}
    get Ignorecdata(){return this.ignoreCdata}
    set Ignorecdata(val){this.ignoreCdata = val}
    get Ignorepi(){return this.ignorePI}
    set Ignorepi(val){this.ignorePI = val}
};

SPLM.Validate.XmlComparator.Result = Object.freeze({
    "Identical" : "Identical", "Different" : "Different"});

export default SPLM;